import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import { ArrowForwardIosSharp } from '@mui/icons-material';

interface MemberAdvancedSearchBoxWithTitleProps {
  title: string;
  children: React.ReactNode;
  noGrid?: boolean; // Optional prop to make Grid wrapper optional
}

export const MemberAdvancedSearchBoxWithTitle = (props: MemberAdvancedSearchBoxWithTitleProps) => {
  const { title, children, noGrid = false } = props;

  // Alla sektioner ligger i ETT gemensamt blått card (se memberAdvancedSearch.tsx). Varje sektion är en
  // transparent, hopfällbar accordion med SAMMA pil-mönster som e-postloggen (memberEmailLogsModal):
  // pilen ligger FÖRE rubriken (flexDirection: row-reverse) och pekar höger (>) när sektionen är stängd,
  // nedåt (rotate 90) när den är öppen.
  const section = (
    <Accordion
      defaultExpanded
      disableGutters
      elevation={0}
      square
      sx={{
        backgroundColor: 'transparent',
        '&:before': { display: 'none' },
        '& .MuiAccordionSummary-root': {
          flexDirection: 'row-reverse',
          minHeight: 'auto',
          px: 0,
          '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
          },
          '& .MuiAccordionSummary-content': {
            ml: 1,
            my: 1,
          },
        },
        // Ta bort AccordionDetails default horisontella padding så fälten linjerar med knapp-raden
        // (som bara har kortets p:2), istället för att vara extra indragna.
        '& .MuiAccordionDetails-root': {
          px: 0,
          pt: 0,
          pb: 0,
        },
      }}
    >
      <AccordionSummary expandIcon={<ArrowForwardIosSharp sx={{ fontSize: '0.9rem' }} />}>
        <Typography sx={{ fontWeight: 500, textTransform: 'uppercase' }} component='span' variant='subtitle2'>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {noGrid && children}
        {!noGrid && (
          <Grid container spacing={2}>
            {children}
          </Grid>
        )}
      </AccordionDetails>
    </Accordion>
  );

  if (noGrid) {
    return section;
  }

  return (
    <Grid item xs={12}>
      {section}
    </Grid>
  );
};
